/**
 * MagicBI Design System - Dark Theme
 * 
 * Complete dark theme configuration with adjusted colors,
 * shadows, and component styling for dark mode.
 */

import {
  darkThemeColors,
  typography,
  spacing,
  semanticSpacing,
  componentSpacing,
  layoutSpacing,
  darkShadows,
  borderRadius,
  borderWidth,
  borderStyle,
  semanticBorderRadius,
  componentBorders,
  borderColors,
  duration,
  easing,
  transitions,
  breakpointValues,
  mediaQueries,
  zIndex,
} from '../tokens';
import type { Theme } from '../types/theme';

export const darkTheme: Theme = {
  mode: 'dark',
  
  colors: darkThemeColors as any,
  
  typography,
  
  spacing: {
    base: spacing,
    semantic: semanticSpacing,
    component: componentSpacing,
    layout: layoutSpacing,
  },
  
  shadows: darkShadows as any,
  
  borders: {
    radius: borderRadius,
    width: borderWidth,
    style: borderStyle,
    semantic: semanticBorderRadius,
    component: componentBorders,
    colors: borderColors.dark,
  },
  
  transitions: {
    durations: duration,
    easing,
    semantic: transitions,
  },
  
  breakpoints: {
    values: breakpointValues,
    mediaQueries,
  },
  
  zIndex,
} as const;

export default darkTheme;
